import React from 'react'
import PropTypes from 'prop-types'
import { SwipeDetector } from '../swipeDetector'
import usePreventPullToRefresh from '../../../hooks/usePreventPullToRefresh'
import { isiOS } from '../../../utils/mobileAppFunctionality'

const PreventRefreshSwipeHandler = ({
  onSwipeDown,
  children,
  skipPreventRefreshOnIOS = false,
}) => {
  const shouldPrevent = !(skipPreventRefreshOnIOS && isiOS())

  if (shouldPrevent) {
    usePreventPullToRefresh()
  }

  return <SwipeDetector onSwipeDown={onSwipeDown}>{children}</SwipeDetector>
}

PreventRefreshSwipeHandler.propTypes = {
  onSwipeDown: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  skipPreventRefreshOnIOS: PropTypes.bool,
}

export { PreventRefreshSwipeHandler }